<template>
  <div
    class="modal fade"
    id="deployConsoleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="deployConsoleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deployConsoleModalLabel">
            <i class="fas fa-terminal mr-2"></i>
            Console do Jenkins
            <span v-if="run"> — {{ run.jenkins_job }}</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" @click="stop">
            <span>&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div v-if="loading && !consoleText" class="text-center py-4">
            <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
          </div>
          <pre v-else ref="consoleBox" class="deploy-console-box">{{ consoleText || "Sem saída ainda..." }}</pre>
        </div>

        <div class="modal-footer">
          <span v-if="polling" class="text-muted mr-auto">
            <i class="fas fa-circle-notch fa-spin mr-1"></i>
            Atualizando automaticamente...
          </span>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="stop">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const OPEN_STATUSES = ["triggered", "running"];
const POLL_INTERVAL_MS = 4000;

export default {
  name: "DeployConsoleModal",

  data() {
    return {
      run: null,
      consoleText: "",
      loading: false,
      polling: false,
      pollTimer: null,
    };
  },

  methods: {
    open(run) {
      this.run = run;
      this.consoleText = "";
      $("#deployConsoleModal").modal("show");

      this.fetchConsole();

      if (OPEN_STATUSES.includes(run.status)) {
        this.polling = true;
        this.pollTimer = setInterval(() => this.fetchConsole(), POLL_INTERVAL_MS);
      }
    },

    async fetchConsole() {
      if (!this.run) return;
      this.loading = true;
      try {
        const api = this.$store.state.api + `deploy-runs/${this.run.id}/console`;
        const res = await axios.get(api);
        this.consoleText = res.data.console || "";
        if (res.data.status && !OPEN_STATUSES.includes(res.data.status)) {
          this.stopPolling();
        }
        this.$nextTick(() => {
          const box = this.$refs.consoleBox;
          if (box) box.scrollTop = box.scrollHeight;
        });
      } catch (e) {
        this.consoleText =
          (e.response && e.response.data && e.response.data.message) ||
          "Não foi possível carregar o console.";
        this.stopPolling();
      } finally {
        this.loading = false;
      }
    },

    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      this.polling = false;
    },

    stop() {
      this.stopPolling();
      $("#deployConsoleModal").modal("hide");
      $("body").removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
  },

  beforeDestroy() {
    this.stopPolling();
  },
};
</script>

<style scoped>
.deploy-console-box {
  background: #1e1e1e;
  color: #d4d4d4;
  border-radius: 6px;
  padding: 14px;
  max-height: 480px;
  overflow-y: auto;
  font-size: 0.78rem;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
  margin-bottom: 0;
}
</style>
